import {Inject, Injectable} from '@angular/core';
import {I18NextPipe} from 'angular-i18next';
import {DOCUMENT} from '@angular/common';
import {Title} from '@angular/platform-browser';

@Injectable()
export class I18NextTitleService extends Title {
    constructor(
        private i18nextPipe: I18NextPipe,
        @Inject(DOCUMENT) doc
    ) {
        super(doc);
    }

    suffix = 'common.page_title_suffix';

    setTitle(title: string, options?: any) {
        return super.setTitle(`${this.translate(title, options)} | ${this.translate(this.suffix)}`);
    }

    private translate(text: string, options: any = {}) {
        return this.i18nextPipe.transform(text, {format: 'cap', ...options});
    }
}
